import { datadogRum } from '@datadog/browser-rum';

export type DatadogRumUser = {
    id: string;
    isKsyos: boolean;
    organizationId: string;
    profession: string;
};

export function isDatadogRumUser(user: unknown): user is DatadogRumUser {
    return (
        typeof user === 'object' &&
        user !== null &&
        'id' in user &&
        'isKsyos' in user &&
        'organizationId' in user &&
        'profession' in user
    );
}

export function getDatadogRumUser(): DatadogRumUser | undefined {
    const user = datadogRum.getUser();

    return isDatadogRumUser(user) ? user : undefined;
}

export function getDatadogRumSessionId(): string | undefined {
    return datadogRum.getInternalContext()?.session_id;
}
